/**
 * The letters a step's mark carries: the first letter of the first two words, so `Market Info`
 * reads `MI` and `Jackie Chan` reads `JC`. Words are split on spaces, hyphens and `&`.
 */
export const getStepInitials = (text: string) =>
  text
    .split(/[\s&-]+/)
    .filter((word) => /\p{L}|\p{N}/u.test(word))
    .slice(0, 2)
    .map((word) => (word.match(/\p{L}|\p{N}/u)?.[0] ?? '').toUpperCase())
    .join('')
